/* eslint-disable */
import React from 'react';
import { SvgIcon } from '@material-ui/core';

export default props => {
  return (
    <SvgIcon {...props}>
      <g
        id="Page-1"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <g
          id="home"
          transform="translate(-177.000000, -738.000000)"
          stroke="currentColor"
        >
          <g
            id="iPhone-X/Bars/Tab-Bar/5-Items"
            transform="translate(0.000000, 722.000000)"
          >
            <g id="Item-3" transform="translate(163.500000, 9.000000)">
              <g id="Icon">
                <g id="Group-453" transform="translate(14.000000, 7.000000)">
                  <path
                    d="M18.9814815,6.78070175 L13.4259259,6.78070175 L13.4259259,1.51754386 C13.4259259,1.03333333 13.0111111,0.640350877 12.5,0.640350877 L7.87037037,0.640350877 C7.35925926,0.640350877 6.94444444,1.03333333 6.94444444,1.51754386 L6.94444444,6.78070175 L1.38888889,6.78070175 C0.877777778,6.78070175 0.462962963,7.17368421 0.462962963,7.65789474 L0.462962963,12.0438596 C0.462962963,12.5280702 0.877777778,12.9210526 1.38888889,12.9210526 L6.94444444,12.9210526 L6.94444444,18.1842105 C6.94444444,18.6684211 7.35925926,19.0614035 7.87037037,19.0614035 L12.5,19.0614035 C13.0111111,19.0614035 13.4259259,18.6684211 13.4259259,18.1842105 L13.4259259,12.9210526 L18.9814815,12.9210526 C19.4925926,12.9210526 19.9074074,12.5280702 19.9074074,12.0438596 L19.9074074,7.65789474 C19.9074074,7.17368421 19.4925926,6.78070175 18.9814815,6.78070175 L18.9814815,6.78070175 Z"
                    id="Stroke-45"
                  ></path>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </SvgIcon>
  );
};
